// No imports needed for this component

export const getOrdersInputs = (initialValues) => [
  {
    type: "SELECT",
    label: "Order Status",
    id: "order_status",
    name: "order_status",
    options: [
      { name: "Pending", value: 1 },
      { name: "In Progress", value: 2 },
      { name: "Shipped", value: 3 },
      { name: "Delivered", value: 4 },
    ],
    value: initialValues?.status || 1,
    placeholder: "Select Order Status",
    validations: [
      {
        type: "REQUIRED",
        message: "Order status is required!",
      },
    ],
  },

  {
    groupName: "Order Details",
    type: "CUSTOM_COMPONENT",
    component: CustomerDetailsComponent,
    orderData: {
      ...initialValues,
      productDetails: initialValues?.order?.[0]?.product_details || {},
    },
  },
];

const CustomerDetailsComponent = ({ formInputs }) => {
  console.log("Form Inputs:", formInputs);
  const orderData = formInputs?.find(
    (item) => item.type === "CUSTOM_COMPONENT"
  )?.orderData;

  console.log("Order Data:", orderData);

  if (!orderData) {
    return <div className="p-4 text-gray-500">Loading order data...</div>;
  }
  return (
    <div className="container p-4 border rounded">

    {/* Order Header */}
    <div className="d-flex justify-content-between align-items-center pb-3 mb-3 border-bottom">
      <div>
        <h4 className="fw-bold mb-1">Order ID: {orderData?.order_id || ""}</h4>
        <span className="text-muted">Date: {orderData?.date || ""}</span>
      </div>
  
      <span className="badge bg-primary px-3 py-2 fs-6">
        {orderData?.status_name || ""}
      </span>
    </div>
  
    {/* Addresses */}
    <div className="row g-4 mb-4">
  
      {/* Billing Address */}
      <div className="col-md-6">
        <h5 className="fw-semibold mb-2">Billing Address</h5>
        <div
          className="address-box p-3 rounded"
          dangerouslySetInnerHTML={{
            __html: orderData?.billing_address || "",
          }}
        />
      </div>
  
      {/* Shipping Address */}
      <div className="col-md-6">
        <h5 className="fw-semibold mb-2">Shipping Address</h5>
        <div
          className="address-box p-3 rounded"
          dangerouslySetInnerHTML={{
            __html: orderData?.shipping_address || "",
          }}
        />
      </div>
  
    </div>
  
    {/* Order Items */}
    <div className="mb-4">
      <h5 className="fw-semibold mb-3">Order Items</h5>
  
      <div className="table-responsive">
        <table className="table table-bordered align-middle">
          <thead className="">
            <tr>
              <th>Manufacturer</th>
              <th>Part Number</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {orderData?.order?.map((item, index) => {
              const product = item.product_details || {};
              return (
                <tr key={index}>
                  <td>{product?.make || "N/A"}</td>
                  <td>{product?.part_number || "N/A"}</td>
                  <td>{item.qty || "0"}</td>
                  <td>{item.selected_price || "0.00"}</td>
                  <td>{item.total_amount || "0.00"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  
    {/* Order Summary */}
    <div className="p-4 rounded">
      <h5 className="fw-semibold mb-3">Order Summary</h5>
  
      <div className="d-flex justify-content-between mb-2">
        <span>Subtotal:</span>
        <span>{orderData?.order_value || "0.00"}</span>
      </div>
  
      <div className="d-flex justify-content-between mb-2">
        <span>Payment Status:</span>
        <span className={orderData?.payment_status === "PAID" ? "fw-bold text-success" : "fw-bold text-danger"}>
          {orderData?.payment_status || "N/A"}
        </span>
      </div>
  
      <div className="d-flex justify-content-between mb-3">
        <span>Order Type:</span>
        <span>{orderData?.order_type || "N/A"}</span>
      </div>
  
      <hr/>
  
      <div className="d-flex justify-content-between fw-bold fs-5">
        <span>Total:</span>
        <span>{orderData?.order_value || "0.00"}</span>
      </div>
    </div>
  
  </div>
  
  );
};
